export default function({ $auth, redirect, store }) {
	if ($auth.$state.loggedIn === false)
		redirect(302, store.IsMobile ? '/mobile/account/login' : '/account/login');
}